<template>
  <div class="row">
    <div class="col-md-12">
      <section class="content">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Branches</h3>

            <div class="card-tools">
              <router-link
                v-if="$gate.isMaster()||($gate.isAdmin()&&$gate.getCompaniesCount())"
                to="/branches/create"
                class="btn btn-sm btn-success"
              >
                <i class="fas fa-plus-circle"></i> New
              </router-link>
            </div>
          </div>
          <div class="card-body p-0 m-2">
            <table id="myTable" class="table table-hover stripe">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th
                    scope="col"
                    v-if="$gate.isMaster()||$gate.isAdmin() && $gate.getCompaniesCount()>1"
                  >Company</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="branch in branches" v-bind:key="branch.id">
                  <td>{{ branch.name }}</td>
                  <td
                    v-if="$gate.isMaster()||$gate.isAdmin() && $gate.getCompaniesCount()>1"
                  >{{ branch.company.name }}</td>
                  <td>
                    <router-link v-bind:to="getEditRoute(branch.id)" class="btn btn-sm btn-warning">
                      <i class="fas fa-pencil-alt"></i> Edit
                    </router-link>
                    <button class="btn btn-sm btn-danger" @click="deleteBranch(branch)">
                      <i class="fas fa-trash"></i> Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import dataTables from "datatables";

export default {
  methods: {
    deleteBranch(branch) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          axios
            .delete("/api/branches/" + branch.id)
            .then(response => {
              this.loadBranches(true);
              Toast.fire({
                icon: "success",
                title: response.data.message
              });
              this.$Progress.finish();
            })
            .catch(error => {
              Toast.fire({
                icon: "error",
                title: error.response.data.message
              });
              this.$Progress.fail();
            });
        }
      });
    },
    loadBranches(change = false) {
      axios({
        method: "get",
        url: "/api/branches"
      }).then(
        response => {
          if (change) {
            this.table.destroy();
          }
          this.branches = response.data.data;
          setTimeout(() => {
            let tableColumns = [0, 1];
            if (this.$gate.isAdmin() && this.$gate.IsAdminForOneCompany()) {
              tableColumns = [0];
            }

            this.table = $(".table").DataTable({
              dom: "Blfrtip",
              retrieve: true,
              pageLength: 20,
              columnDefs: [
                {
                  targets: tableColumns[tableColumns.length - 1] + 1,
                  orderable: false
                }
              ],
              buttons: [
                {
                  extend: "csv",
                  text: '<i class="fas fa-file-csv"></i>',
                  exportOptions: {
                    columns: tableColumns
                  }
                },
                {
                  extend: "excel",
                  text: '<i class="fas fa-file-excel"></i>',
                  exportOptions: {
                    columns: tableColumns
                  }
                }
              ]
            });
          }, 0);
        },
        error => {
          console.log(error);
        }
      );
    },
    getEditRoute(id) {
      return "/branches/" + id + "/edit";
    }
  },
  data() {
    return {
      branches: [],
      table: ""
    };
  },
  mounted() {
    this.loadBranches();
  }
};
</script>
